import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { firstAccessibleNavTarget } from "../navigation/navigation";

// Para onde aterrar ao entrar. O Dashboard é a página por omissão, mas um utilizador sem acesso
// ao Dashboard caía nele e via só erros "Forbidden" — em vez disso, leva-se à primeira área a que
// tem acesso. Sem nenhuma, uma mensagem clara em vez de uma página partida. A equipa interna
// (TeamMember) é encaminhada pelo RequireBackOffice para a Folha de Horas, antes disto.
export function LandingRedirect() {
  const { user } = useAuth();
  const isAdmin = user?.roles?.includes("Administrator") ?? false;
  const target = firstAccessibleNavTarget(isAdmin, user?.features);

  if (target) {
    return <Navigate to={target} replace />;
  }

  return (
    <div className="flex flex-col h-full items-center justify-center p-6 text-center">
      <p className="text-foreground" style={{ fontWeight: "var(--font-weight-medium)" }}>
        A sua conta ainda não tem acesso a nenhuma área.
      </p>
      <p className="text-sm text-secondary-text mt-1">
        Contacte um administrador para lhe atribuir um cargo na Gestão de Acessos.
      </p>
    </div>
  );
}
